export const animationTime = 1000;
